import React, { useState, useEffect } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';

import { request } from '../../../interfaces/networkManager';
import Error from '../../../components/Error/Error';
import { CustomPaper } from '../styles';
import { UserDTO } from '../../../models/userDTO';

const columns: GridColDef[] = [
	{
		field: 'displayName',
		headerName: 'Nom',
		flex: 1.5,
	},
	{
		field: 'email',
		headerName: 'Email',
		flex: 1.5,
		valueGetter: (value) => {
			if (!value) {
				return '-';
			}
			return value;
		},
	},
	{
		field: 'phone',
		headerName: 'Téléphone',
		flex: 0.9,
		valueGetter: (value, row) => {
			if (!row.person) {
				return '-';
			}
			return row.person.phone;
		},
	},
];

const initialState = {
	initialState: {
		sorting: {
			sortModel: [{ field: 'displayName', sort: 'desc' }],
		},
	},
	pagination: {
		paginationModel: {
			pageSize: 5,
		},
	},
};

const UserDetails = () => {
	const [prospects, setProspects] = useState<UserDTO[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		request<UserDTO[]>('/users/get-prospects')
			.then((response: UserDTO[]) => {
				if (!response.length) return setError('Erreur lors de la récupération des prospects');
				setProspects(response);
			})
			.catch((error: string) => {
				setError('Erreur lors de la récupération des informations générales');
			});
	}, []);

	return (
		<CustomPaper>
			<Typography variant="h5" color="primary" gutterBottom align="left">
				Tous nos prospects :
			</Typography>
			{error && <Error message={error} />}
			{!!prospects.length ? (
				<Box height={400} width="100%">
					<DataGrid getRowId={(row) => row.idPerson} rows={prospects} columns={columns} initialState={initialState} pageSizeOptions={[5]} slots={{ toolbar: GridToolbar }} disableRowSelectionOnClick />
				</Box>
			) : !error ? (
				<Box justifyContent="center" alignItems="center" display="flex" width="100%" minHeight="25rem">
					<CircularProgress />
				</Box>
			) : null}
		</CustomPaper>
	);
};

export default UserDetails;
